import React from 'react';
import { autobind } from 'react-decoration';
import qs from 'query-string';

import Pagination from './Pagination';
import { navigate } from "gatsby"
import withLocation from 'lib/withLocation';
import $ from 'jquery'

@withLocation
class IntegrationPagination extends Pagination {
  constructor(props) {
    super(props);
    this.state = {
      info: {
        nowpage: Math.ceil(props.start / props.limit) + 1, //props.startPageNo
        nextpage: false,
        lastpage: props.pageNo < props.totalPage || props.pageNo < props.totalPage
      }
    };

    this.showPage = React.createRef();
    this.pagination = React.createRef();
  }

  componentWillReceiveProps(props) {
    const {startPageNo} = props;
    let nowpage = Math.max(
      0,
      Math.floor(
        $('.showPageNo').filter(function(k, v) {
          return Math.ceil($(window).scrollTop() + (55 + 64)) >= Math.floor($(v).offset().top);
        }).length
      ) - 1
    ) + startPageNo;


    let info = {
      nowpage,//: Math.ceil(props.start / props.limit) + 1, //props.startPageNo
      nextpage: false,
      lastpage: props.pageNo < props.totalPage || props.pageNo < props.totalPage
    }
    this.setState({info});
  }

  @autobind
  changePageSize(e) {
    let { search, location } = this.props;

    let params = { ...search, limit: e.target.value };
    delete params['pageNo'];
    navigate([location.uri, qs.stringify(params)].join('?'));
  }

  componentDidMount(){  
      $(window).on('scroll',this.fixPage);          
  }

  componentWillUnmount(){
      $(window).off('scroll',this.fixPage);  
  }

  fixPage = () => {        
    const { startPageNo, totalPage, showPrevious, showNext, pageNo } = this.props;
    window.$ = $;
    /*
    if (
      $(this.pagination.current).offset().top >
      $('.data_content').height() + $('.data_content').offset().top - 50
    ) {
      this.setState({ fixed: '' });
    } else {
      this.setState({ fixed: 'fixed' });
    }*/

    let nowpage =
      Math.max(
        0,
        Math.floor(
          $('.showPageNo').filter(function(k, v) {
            return Math.ceil($(window).scrollTop() + (55 + 64)) >= Math.floor($(v).offset().top);
          }).length
        ) - 1
      ) + startPageNo;

   // nowpage = Math.min(nowpage, totalPage);

    let loadTotalPage = $('.showPageNo').length;

    let nps = [];
    for (var np = Math.max(1, nowpage - 3); np <= Math.min(nowpage + 3, totalPage); np++) {
      nps.push(np);
    }

    var info = {
      prevpage: showPrevious || nowpage > 1 || startPageNo < nowpage,
      nowpage: nowpage,
      nextpage: loadTotalPage > nowpage || showNext || nowpage < totalPage,
      lastpage: pageNo < totalPage || nowpage < totalPage,
      nps: nps
    };

    if (
      info.prevpage != this.state.info.prevpage ||
      info.nowpage != this.state.info.nowpage ||
      info.nextpage != this.state.info.nextpage ||
      info.lastpage != this.state.info.lastpage
    ) {
      this.setState({ info: info });
    }
  }

  LoadMore= () => {
    const { total,iTotal } = this.props;
    let params = qs.parseUrl(window.location.href).query
    delete params.filterPid;
    delete params.sort;
    delete params.pageNo;
    params.fetch = Math.min(total + 60 , iTotal)
    navigate(["/searchResult",qs.stringify(params)].join("?"))
  }

  render() {
    const { nowpage, lastpage: isLastpage } = this.state.info;
    const {
      t,
      totalPage,
      pages,
      total,
      goPage,
      showNext,
      showPrevious,
      iFilterTotal,
      iTotal,
      limit,
      showpage,
      hasFilter,
      nFilterTotal,
      fetchMore,
      process,
      fetchMoreProcess,
      startPageNo
    } = this.props;
    let prevPage = Math.max(1, nowpage - 1);

    let params = qs.parseUrl(window.location.href).query;
    let {filterField , db} = params;
    filterField = filterField || [];
    db = db || [];
    if (typeof filterField === 'string') {
      filterField = [filterField];
    }
    if (typeof db === 'string') {
      db = [db];
    }
    let filterNonDBNum = filterField.filter(f=>{ if(f!="db"){return 1}});
    let filterDBNum = filterField.filter(f=>{ if(f=="db"){return 1}});
    let showLoadMore = false;

    
    if(filterNonDBNum.length==0&&(db.length==1||filterDBNum.length==1)){
      if(total<iFilterTotal)
        showLoadMore = true;
    }

    if (totalPage == 0) {
      return null;
    }

    return (
      <>
        <div ref={this.showPage}>{/*showPage*/}</div>
        <section ref={this.pagination} className="pagination fixed">         
          <ul className="page">           
            <li className="first">
              <a
                href="javascript:;"
                tabIndex="0"
                title={t`common:webpac.button.firstpage`}
                onClick={() => goPage(1)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    goPage(1);
                  }
                }}
              >
                {t`common:webpac.button.firstpage` + ' '}
              </a>
            </li>
            {showPrevious && (
              <li className="prev">
                <a
                  href="javascript:;"
                  tabIndex="0"
                  onClick={() => goPage(prevPage)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      goPage(prevPage);
                    }
                  }}
                  title={t`common:webpac.button.back`}
                >
                  {t`common:webpac.button.back` + ' '}
                </a>
              </li>
            )}
            <li className="active"><a>{nowpage}</a></li>
            {/*           
            {pages.map((page, key) => {
              return (
                <li key={`page_${key}`} className={page.active ? 'active' : ''}>
                  <a href="javascript:;" onClick={() => goPage(page.val)}>
                    {page.val}
                  </a>
                </li>
              );
            })}*/}
            {(showNext || showLoadMore) && (
              <li className="next">
                <a
                  href="javascript:;"
                  tabIndex="0"
                  title={t`common:webpac.button.nextpage`}
                  onClick={() => goPage(nowpage + 1)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      goPage(nowpage + 1);
                    }
                  }}
                >
                  {t`	common:webpac.button.nextpage` + ' '}
                </a>
              </li>
            )}
            {isLastpage && (
              <li className="last">
                <a
                  href="javascript:;"
                  tabIndex="0"
                  title={t`common:webpac.button.lastpage`}
                  onClick={() => goPage(totalPage)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      goPage(totalPage);
                    }
                  }}
                >
                  {t`common:webpac.button.lastpage` + ' '}
                </a>
              </li>
            )}
            {
              !isLastpage && showLoadMore && (
                <li>
                  <a
                    href="javascript:;"
                    tabIndex="0"
                    title={t`common:webpac.button.nextpage`}
                    onClick={this.LoadMore}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        this.LoadMore(e);
                      }
                    }}
                  >
                    LoadMore 
                  </a>
                </li>
              )  
            }
            {/*<li className="active">{fetchMoreProcess?"load...":""} {startPageNo}</li>*/}
          </ul>
          {/*
          <form action="" className="form_inline">
            {hasFilter ? (
              <div className="total">
                共
                <span>{nFilterTotal}</span>
                筆資料，去重後
                <span>{total}</span>
                筆，第
                <span>{nowpage}/{totalPage}</span>
                頁
              </div>
            ) : (
              <div className="total">
                共
                <span>{total}</span>
                筆資料，第
                <span>{nowpage}/{totalPage}</span>
                頁
              </div>
            )}
            </form>*/}
        </section>
      </>
    );
  }
}

export default IntegrationPagination;